<template>
  <section id="pos_container">
    <Styles>
      <div class="columns">
        <div class="column">
          <CompanySelector v-model="company" />
        </div>
        <div class="column">
          <b-field label="Nombre de la caja">
            <b-input
              type="text"
              v-model="name"
              name="name"
              v-validate="'required'"
            ></b-input>
          </b-field>
          <span class="show-error">{{ errors.first("name") }}</span>
        </div>
        <div class="column">
          <b-field label="Tienda">
            <b-select
              placeholder="Seleccione una Tienda..."
              expanded
              v-model="store"
              v-validate="'required'"
              name="store"
            >
              <option
                v-for="option in stores"
                :value="option.code"
                :key="option.code"
                :id="option.code"
              >
                {{ option.title }}
              </option>
            </b-select>
          </b-field>
          <span class="show-error">{{ errors.first("store") }}</span>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <b-field label="External Id">
            <b-input
              placeholder="Ingrese el External Id"
              type="text"
              v-model="externalId"
              name="externalId"
              v-validate="'required'"
              :disabled="!externalIdChecked"
            ></b-input>
          </b-field>
          <span class="show-error">{{ errors.first("externalId") }}</span>
        </div>
        <div class="column" style="margin-top: 40px">
          <b-field>
            <b-checkbox v-model="fixedAmount"> Restringir monto </b-checkbox>
          </b-field>
        </div>
      </div>
      <hr v-if="selected" />
      <label v-if="selected" class="flex flex-center">Token</label>
      <div class="columns">
        <div class="column">
          <div class="cont-copy" v-if="selected">
            <div class="text-copy">
              <span style="font-size: 10px" @click="copyClose">{{
                token
              }}</span>
            </div>
            <input type="hidden" id="code-image-close" :value="token" />
          </div>
        </div>
      </div>
      <div class="columns" v-if="qr">
        <div class="column is-4"></div>
        <div class="column is-4 qr-container">
          <img :src="qr" class="img-qr" alt="Qr mercadopago" @click="openUrl" />
          <a
            :href="qrDownloadLink"
            class="button is-info link-button mt-3"
            target="_blank"
          >
            <span><i class="mr-2 mdi mdi-download"></i> Descargar PDF</span>
          </a>
        </div>
      </div>
      <div class="columns resume" v-if="selected">
        <div class="column">
          <div class="block">
            <label>URL para crear la orden: </label>
            <code class="code-link">{{ urlCreateOrder }}</code>
          </div>
          <div class="block">
            <label>URL para consultar la orden: </label>
            <code class="code-link">{{ urlQueryOrder }}</code>
          </div>
          <div class="block">
            <label>URL para cancelar la orden: </label>
            <code class="code-link">{{ urlCancelOrder }}</code>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-table
            :data="tableData"
            :selected.sync="selected"
            focusable
            :paginated="true"
            :per-page="5"
            :bordered="true"
            :current-page.sync="currentPage"
          >
            <b-table-column field="title" label="Nombre Caja" v-slot="props">
              {{ props.row.title }}
            </b-table-column>
            <b-table-column field="mpId" label="Id MercadoPago" v-slot="props">
              {{ props.row.mpId }}
            </b-table-column>
            <b-table-column
              field="externalId"
              label="External Id"
              v-slot="props"
            >
              {{ props.row.externalId }}
            </b-table-column>
            <b-table-column field="storeTitle" label="Tienda" v-slot="props">
              {{ props.row.store.title }}
            </b-table-column>
            <template #bottom-left> </template>
            <template #empty>
              <div class="has-text-centered">Sin registros</div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="columns" v-if="responseError">
        <div class="column">
          <h2 class="error-title">Salida del error:</h2>
          <code class="response-error">
            {{ responseError }}
          </code>
        </div>
      </div>
      <div class="buttons button-group">
        <b-button @click="save()" type="is-info" v-if="selected == null">
          Guardar
        </b-button>
        <b-button @click="save()" type="is-info" v-if="selected != null">
          Editar
        </b-button>
        <b-button
          v-if="selected != null"
          @click="openDeleteModal()"
          type="is-danger"
          icon-right="delete"
        >
          Eliminar
        </b-button>
      </div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </Styles>
  </section>
</template>

<script>
import CompanySelector from "../../components/Shared/CompanySelector";
import { ROUTES } from "../../global/api_routes";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { confirmation } from "../../global/utils";
import { configToast, TOAST_TYPES } from "../../global/toast";
import Styles from "./styles";
export default {
  name: "Pos",
  components: { CompanySelector, Styles },
  data: () => ({
    id: null,
    company: null,
    name: null,
    externalId: null,
    mpId: null,
    store: null,
    token: null,
    selected: null,
    qr: null,
    isLoading: false,
    fixedAmount: true,
    currentPage: 1,
    stores: [],
    tableData: [],
    companies: [],
    externalIdChecked: false,
    responseError: null,
    urlCreateOrder: null,
    urlQueryOrder: null,
    urlCancelOrder: null,
  }),
  mounted() {
    let url = process.env.VUE_APP_URL;
    if (!/^http:/.test(url)) {
      url = (location.origin + location.pathname).split(/view/);
      url = url[0];
    }
    this.urlCreateOrder = `${url}api/${ROUTES.DASHBOARD.MP.CREATE}`;
    this.urlQueryOrder = `${url}api/${ROUTES.DASHBOARD.MP.QUERY}`;
    this.urlCancelOrder = `${url}api/${ROUTES.DASHBOARD.MP.CANCEL}`;
  },
  watch: {
    async company() {
      if (this.company) {
        this.isLoading = true;
        const storesList = await this.listStores();
        const listBox = await this.listBox();
        this.stores = storesList.data.code > 0 ? storesList.data.info : [];
        this.tableData = listBox.data.code > 0 ? listBox.data.info : [];
        this.isLoading = false;
        this.findExternalId();
        return;
      }
      this.selected = null;
      this.company = null;
      this.store = null;
      this.stores = [];
    },
    store() {
      this.findExternalId();
    },
    selected() {
      console.log(this.selected);
      if (this.selected != null) {
        this.fillData(this.selected);
      }
    },
  },
  methods: {
    async findExternalId() {
      if (!this.company || !this.store) {
        return;
      }
      this.isLoading = true;
      const externalId = await this.getExternalId(this.company, this.store);
      if (externalId.data.code > 0) {
        this.externalId = externalId.data.info;
        this.externalIdChecked = true;
      }
      this.isLoading = false;
    },
    openUrl() {
      window.open(this.qr, "_blank").focus();
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#pos_container");
      return instance.open(message, type);
    },
    openDeleteModal() {
      confirmation(this, `¿Desea eliminar la caja?`).then((result) => {
        if (!result) {
          return;
        }
        this.deleteBox();
      });
    },
    deleteBox() {
      this.$http
        .delete(ROUTES.DASHBOARD.MERCADO_PAGO.POS.DELETE, {
          data: {
            posId: this.id,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.cleanForm();
          }
        });
    },
    save() {
      this.responseError = null;
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        if (
          this.selected != null &&
          this.selected.externalId == this.externalId
        ) {
          this.toast("Debe modificar el external id", TOAST_TYPES.ERROR);
          return;
        }
        if (this.selected != null && this.selected.title == this.name) {
          this.toast("Debe modificar el nombre", TOAST_TYPES.ERROR);
          return;
        }
        const trimmed = this.externalId.replace(/\s/g, "");
        const send = {
          code: this.id,
          title: this.name,
          store: {
            code: this.store,
          },
          externalId: trimmed,
          fixedAmount: this.fixedAmount,
          mpId: this.mpId,
        };
        if (send.code == null) {
          delete send.code;
        }
        if (send.mpId == null) {
          delete send.mpId;
        }
        this.isLoading = true;
        const options = {
          method: this.selected ? "PUT" : "POST",
          data: send,
          url: this.selected
            ? ROUTES.DASHBOARD.MERCADO_PAGO.POS.UPDATE
            : ROUTES.DASHBOARD.MERCADO_PAGO.POS.SAVE,
        };
        this.$http(options)
          .then(({ data }) => {
            if (data.code > 0) {
              this.isLoading = false;
              this.toast(data.message, TOAST_TYPES.SUCCESS);
              this.getPosList();
              this.cleanForm();
              return;
            }
            this.isLoading = false;
            this.toast(data.message, TOAST_TYPES.ERROR);
          })
          .catch(({ response }) => {
            this.isLoading = false;
            this.toast(response.data.message, TOAST_TYPES.ERROR);
          });
      });
    },
    cleanForm() {
      this.id = null;
      this.name = null;
      this.fixedAmount = null;
      this.store = null;
      this.token = null;
      this.externalId = null;
      this.isLoading = false;
      this.selected = null;
      this.qr = null;
      this.stores = [];
      this.tableData = [];
    },
    fillData(selected) {
      this.id = selected.code;
      this.name = selected.title;
      this.externalId = selected.externalId;
      this.fixedAmount = selected.fixedAmount;
      this.store = selected.store.code;
      this.token = selected.token;
      this.mpId = selected.mpId;
      const dataParsed = JSON.parse(selected.response);
      this.qr = dataParsed.qr.image;
      this.qrDownloadLink = dataParsed.qr.templateImage;
      this.isLoading = false;
    },
    listStores() {
      return this.$http.get(ROUTES.DASHBOARD.MERCADO_PAGO.POS.LIST, {
        params: {
          companyId: this.company,
        },
      });
    },
    copyClose() {
      let testingCodeToCopy = document.querySelector("#code-image-close");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        this.toast("texto copiado " + msg, TOAST_TYPES.SUCCESS);
      } catch (err) {
        this.toast(`Error al copiar texto ` + msg, TOAST_TYPES.ERROR);
      }
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    async getPosList() {
      this.isLoading = true;
      const listBox = await this.listBox();
      this.tableData = listBox.data.code > 0 ? listBox.data.info : [];
      this.isLoading = false;
    },
    listBox() {
      return this.$http.get(ROUTES.DASHBOARD.MERCADO_PAGO.POS.LIST, {
        params: {
          companyId: this.company,
        },
      });
    },
    getSchedules() {
      this.$http
        .get(ROUTES.DASHBOARD.SCHEDULES.GET_SCHEDULES, {
          params: {
            companyId: this.company,
            title: "",
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.schedules = data.info;
          }
        });
    },
    getExternalId(companyId, storeId) {
      return this.$http.get(ROUTES.DASHBOARD.MERCADO_PAGO.GET_EXTERNAL_ID, {
        params: {
          companyId,
          storeId,
        },
      });
    },
  },
};
</script>
<style type="scss">
.img-qr {
  height: 300px;
  width: 300px;
  cursor: pointer;
}
.text-copy {
  background: #91d18b;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  width: fit-content;
  cursor: pointer;
  margin: 0 auto;
}
.cont-copy {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
</style>
